import React from 'react';
export function RulesSection() {
  return <section className="text-lg leading-relaxed text-[#1B1B2F]" data-id="element-284">
      <div className="bg-[#F9F8F6] p-8 rounded-lg border border-gray-200 my-8" data-id="element-285">
        <h3 className="text-2xl font-bold text-[#2B4C7E] mb-6 text-center uppercase tracking-wider" data-id="element-286">
          4 Regeln, die ich gelernt habe
        </h3>
        <div className="space-y-6" data-id="element-287">
          <div data-id="element-288">
            <h4 className="font-bold text-lg mb-1" data-id="element-289">
              1. Nicht die maximale Dosis, sondern die richtige
            </h4>
            <p data-id="element-290">
              Der Körper braucht nicht die höchste Dosierung, sondern diejenige,
              die genau zu Ihnen passt.
            </p>
          </div>
          <div data-id="element-291">
            <h4 className="font-bold text-lg mb-1" data-id="element-292">
              2. Vitamin D muss im Gleichgewicht mit K2 eingenommen werden
            </h4>
            <p data-id="element-293">
              Vitamin K2 ist der „Regler". Nur er kennt den Weg zu den Knochen
              und Zähnen. Ohne ihn geht das Kalzium in Ihre Gefäße und Nieren.
            </p>
          </div>
          <div data-id="element-294">
            <h4 className="font-bold text-lg mb-1" data-id="element-295">
              3. Die richtige Form der „Zustellung"
            </h4>
            <p data-id="element-296">
              Vitamin D ist ein fettlösliches Vitamin, daher muss Öl im Inhalt
              sein. Aber suchen Sie nicht nach einfachen Tropfen. Suchen Sie
              nach Kapseln, in denen das Öl (am besten ein natürliches) in
              trockener Form versiegelt ist. Dies garantiert, dass das Vitamin
              nicht an den Rachenwänden hängen bleibt, sondern direkt in den
              Dünndarm gelangt, wo es wirken soll.
            </p>
          </div>
          <div data-id="element-297">
            <h4 className="font-bold text-lg mb-1" data-id="element-298">
              4. Mit dem Alter ändern sich die Bedürfnisse des Körpers
            </h4>
            <p data-id="element-299">
              Der Ansatz „ein Vitamin für alle" berücksichtigt nicht immer das
              Alter und die Besonderheiten des Stoffwechsels. Daher empfehlen
              Fachleute immer häufiger, sogenannten age-optimierte Nährstoffe
              den Vorzug zu geben – Formeln, die an das Alter angepasst sind.
            </p>
          </div>
        </div>
      </div>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-300">
        Was sind age-optimierte Nährstoffe?
      </h2>
      <p className="mb-4" data-id="element-301">
        Age-optimierte Nährstoffe sind Nährstoffe, deren Zusammensetzung und
        Dosierung unter Berücksichtigung der altersbedingten Veränderungen des
        Körpers berechnet wurden. Solche Formeln werden nicht nach dem Prinzip
        „passt allen" erstellt, sondern unter Berücksichtigung dessen, wie genau
        sich der Stoffwechsel nach 50–60 Jahren verändert.
      </p>
      <p className="mb-4" data-id="element-302">
        Mit dem Alter ändert sich nicht nur der Bedarf an Stoffen, sondern auch,
        wie der Körper sie verwendet, verteilt und aufnimmt. Daher kann dieselbe
        Dosierung bei einem 25-Jährigen und einem 55-Jährigen unterschiedlich
        wirken.
      </p>

      <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-303">
        Warum sich der Stoffwechsel nach 50 ändert
      </h3>
      <p className="mb-4" data-id="element-304">
        Nach dem 50. Lebensjahr finden im Körper allmählich natürliche
        physiologische Veränderungen statt:
      </p>
      <ul className="list-disc list-inside ml-4 mb-6 space-y-1" data-id="element-305">
        <li data-id="element-306">
          die Fähigkeit der Haut, Vitamin D unter Sonneneinstrahlung zu
          synthetisieren, sinkt
        </li>
        <li data-id="element-307">die hormonelle Regulierung des Kalziumstoffwechsels ändert sich</li>
        <li data-id="element-308">
          die Erneuerung des Knochengewebes verlangsamt sich (Remodelling)
        </li>
        <li data-id="element-309">die Effizienz der Aufnahme bestimmter Nährstoffe im Darm sinkt</li>
        <li data-id="element-310">
          die Funktion der Gefäßwände und die Verteilung von Mineralien ändert
          sich
        </li>
      </ul>
      <p className="mb-4" data-id="element-311">
        Dies ist keine Krankheit, sondern die normale Biologie des reifen
        Organismus. Aber genau deshalb funktionieren frühere Dosierungen und
        Standardformeln möglicherweise nicht mehr optimal. Für den Körper werden
        das Gleichgewicht, die Form und die Kombination der Stoffe wichtig,
        nicht einfach nur eine hohe Dosierung.
      </p>
    </section>;
}